<template>
    <b-modal
            id="form-record-catch-new-fisherman-modal"
            ref="form-record-catch-new-fisherman-modal"
            cancel-variant="outline-secondary"
            ok-title="Mentés"
            cancel-title="Mégsem"
            @ok.prevent="handleOk"
            centered
            title="Új horgász hozzáadása"
    >
        <!-- form -->
        <validation-observer ref="simpleRules">
            <b-form>
                <b-row>
                    <b-col md="12">
                        <b-form-group
                                label="Felhasználó"
                        >
                            <validation-provider
                                    #default="{ errors }"
                                    name="felhasználó"
                                    rules="required"
                                    vid="user"
                            >
                                <v-select
                                        v-model="formData.user"
                                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                        label="title"
                                        :clearable="false"
                                        :options="userOptions"
                                >
                                    <template #no-options>
                                        <span style="">Sajnáljuk, nincs egyező találat.</span>
                                    </template>
                                </v-select>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>

                    <b-col md="12">
                        <b-form-group
                                label="Név"
                        >
                            <validation-provider
                                    #default="{ errors }"
                                    name="név"
                                    rules="required"
                                    vid="name"
                            >
                                <b-form-input
                                        v-model="formData.name"
                                        :state="errors.length > 0 ? false:null"
                                        placeholder="név"
                                />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group
                                label="Nem"
                        >
                            <validation-provider
                                    #default="{ errors }"
                                    name="nem"
                                    rules="required"
                                    vid="gender"
                            >
                                <v-select
                                        v-model="formData.gender"
                                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                        label="title"
                                        :options="genderOptions"
                                >
                                    <template #no-options>
                                        <span style="">Sajnáljuk, nincs egyező találat.</span>
                                    </template>
                                </v-select>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group
                                label="Ország"
                        >
                            <validation-provider
                                    #default="{ errors }"
                                    name="ország"
                                    rules="required"
                                    vid="nationality"
                            >
                                <v-select
                                        v-model="formData.nationality"
                                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                        label="title"
                                        :options="nationalityOptions"
                                >
                                    <template #no-options>
                                        <span style="">Sajnáljuk, nincs egyező találat.</span>
                                    </template>
                                </v-select>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>

                    <b-col md="12">
                        <b-form-group
                                label="Születési dátum"
                        >
                            <validation-provider
                                    #default="{ errors }"
                                    name="születési dátum"
                                    rules=""
                                    vid="birthday"
                            >
                                <flat-pickr
                                        v-model="formData.birthday"
                                        class="form-control"
                                        :config="flatPickRConfig"
                                />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>

                    <b-col md="12">
                        <b-form-group
                                label="Horgászkártya száma (horgászazonosító)"
                        >
                            <validation-provider
                                    #default="{ errors }"
                                    name="horgászkártya száma (horgászazonosító)"
                                    rules=""
                                    vid="fishingCardNumber"
                            >
                                <b-form-input
                                        v-model="formData.fishingCardNumber"
                                        :state="errors.length > 0 ? false:null"
                                        placeholder="horgászkártya száma (horgászazonosító)"
                                />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>

                </b-row>
            </b-form>
        </validation-observer>
    </b-modal>
</template>

<script>

import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {
    BFormInput, BFormGroup, BForm, BRow, BCol, BButton, BFormCheckbox,
} from 'bootstrap-vue'
import {
    required,
} from '@validations'
import vSelect from 'vue-select'
import BCardCode from "@core/components/b-card-code";
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css';
import {Hungarian} from 'flatpickr/dist/l10n/hu.js'
import {formatDateAllowedSymbols, formatTimeAllowedSymbols} from "@core/utils/filter";

export default {
    components: {
        BCardCode,
        ValidationProvider,
        ValidationObserver,
        BFormInput,
        BFormGroup,
        BForm,
        BRow,
        BCol,
        BButton,
        BFormCheckbox,
        vSelect,
        flatPickr,
    },
    data() {
        return {
            role: 'record_catch',
            formData: {
                name: '',
                gender: '',
                nationality: '',
                birthday: '',
                fishing_card_number: '',
                user: '',
            },
            userOptions: [],
            genderOptions: [],
            nationalityOptions: [],
            flatPickRConfig: {
                enableTime: false,
                dateFormat: 'Y-m-d',
                locale: Hungarian,
                allowInput: true
            },
            formatDateAllowedSymbols,
            formatTimeAllowedSymbols,
            required,
        }
    },
    methods: {
        setUser(userId) {
            this.formData = {
                name: '',
                gender: '',
                nationality: '',
                birthday: '',
                fishing_card_number: '',
                user: '',
            }

            this.$store.dispatch('fetchUsersForSelect').then(response => {
                this.userOptions = response

                Object.keys(response).forEach(key => {
                    if (parseInt(response[key].value) === parseInt(userId)) {
                        this.formData.user = {
                            value: response[key].value,
                            title: response[key].title
                        }
                    }
                })
            })

            this.$store.dispatch('fetchNationalitiesForSelect').then(response => {
                this.nationalityOptions = response

                if (this.nationalityOptions.length) {
                    this.formData.nationality = {
                        value: 'HU',
                        title: 'Magyarország'
                    }
                }
            })

            this.$store.dispatch('fetchGendersForSelect').then(response => {
                this.genderOptions = response

                if (this.genderOptions.length) {
                    this.formData.gender = this.genderOptions[0]
                }
            })
        },
        handleOk() {
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    // clone formData
                    let fd = JSON.parse(JSON.stringify(this.formData))
                    fd.nationality = this.formData.nationality.value
                    fd.gender = this.formData.gender.value
                    fd.user = this.formData.user.value
                    this.$store.dispatch('storeFisherman', fd).then(response => {
                        console.log(response.data.entity.id)
                        this.$emit('refresh-fishermen', response.data.entity.id)
                        this.$helpers.showSuccessToast('Új horgász létrehozva.')
                        this.$bvModal.hide("form-record-catch-new-fisherman-modal");
                    }).catch(error => {
                        if (error.response.status === 422) {
                            this.$refs.simpleRules.setErrors(error.response.data.errors)
                        } else {
                            this.$helpers.showErrorToast(error.toString())
                        }
                    })
                }
            })
        },
    },
}
</script>
